import * as turf from '@turf/turf';

/**
 * String 변의 방향 — PanelPlanningPage 백업·getModuleCellCorners 와 동일 규칙
 * bearing ≈ 0°/180°(세로) → height, ≈ 90°(가로) → width
 */
export function getWidthOrHeight(pt1, pt2) {
  const angle = Math.abs(turf.bearing(pt1, pt2));
  const dist = turf.distance(pt1, pt2);
  if (angle <= 45 || angle >= 135) {
    return { type: 'height', distance: dist };
  }
  return { type: 'width', distance: dist };
}
